import { render, staticRenderFns } from "./PTCWall.vue?vue&type=template&id=84467a38&"
import script from "./PTCWall.vue?vue&type=script&lang=js&"
export * from "./PTCWall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports